<template>
  <div class="popup-main">
    <el-dialog
      :title="detailId ? '编辑工区' : '新增工区'"
      width="800px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <div v-if="loaded">
          <e-form
            ref="refForm"
            :config="formConfig"
            :column="formColumn"
            :rules="formRules"
            :data.sync="selfData"
          />
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    parentId: {
      type: [Number, String],
      required: true
    },
    parentName: {
      type: String,
      required: true
    },
    detailId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      loaded: false,
      selfShow: false,
      selfData: {
        parent_id: '',
        parent_name: '',
        id: '',
        code: '',
        name: '',
        curator: '',
        remark: '',
        status: true
      },
      formConfig: {
        inline: false,
        width: '100%'
      },
      formColumn: [
        {
          type: 'text',
          title: '所属工作地点',
          field: 'parent_name',
          disabled: true
        },
        {
          type: 'number',
          title: '工区编码',
          field: 'code',
          placeholder: '自动生成',
          disabled: true
        },
        {
          type: 'text',
          title: '工区名称',
          field: 'name',
          required: true
        },
        {
          type: 'text',
          title: '负责人',
          field: 'curator'
        },
        {
          type: 'text',
          title: '描述',
          field: 'remark'
        },
        {
          type: 'switch',
          title: '状态',
          field: 'status'
        }
      ],
      formRules: {
        name: [{ required: true, message: '请输入工区名称' }]
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.detailId) {
      this.getDetailData()
    } else {
      this.initSelfData()
    }
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      this.loaded = false
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/gongqu2/detail',
        params: {
          id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.data)
          this.selfData = result
        }
      })
      this.loaded = true
    },
    // 初始化数据
    initSelfData() {
      this.loaded = false
      this.selfData.parent_id = this.parentId
      this.selfData.parent_name = this.parentName
      this.loaded = true
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$api({
            method: 'post',
            url: '/admin/gcvip/gongqu2/saveOrUpdate',
            data: {
              form_data: this.selfData
            }
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.popupCancel()
                this.$emit('success')
                this.$message.success('保存成功')
              }
            })
            .catch((error) => {
              this.$message.error(error)
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
